import { instance } from "api/apiBase";
import { type IntegrationCredentialSummary } from "shared/types";

export const QUERY_GET_PROPERTIES_COMPACT = "PROPERTIES_COMPACT";
export const QUERY_GET_PROPERTIES_COMPACT_WITH_PHONE =
  "PROPERTIES_COMPACT_WITH_PHONE";

export type AssignedPhoneNumber = {
  comm_id: string | null;
  phone_number: string;
  name: string | null;
};

export type CompactProperty = {
  id: number;
  name: string;
  // The public listing payload identifies a property by slug only, so anything that
  // has to line a portal selection up against a listing needs this (CRM-1240).
  slug: string;
  property_group_name: string | null;
  address: string | null;
  pms_id: string | null;
  integration_credential: IntegrationCredentialSummary | null;
  // Only returned when withPhoneAssignments is requested (AI-396).
  assigned_phone_number?: AssignedPhoneNumber | null;
};

type CompactPropertiesResponse = {
  items: CompactProperty[];
};

const api = {
  getCompactProperties: async (opts?: {
    withPhoneAssignments?: boolean;
  }): Promise<CompactPropertiesResponse> => {
    return (
      await instance.get<CompactPropertiesResponse>(
        "/portal/v1/properties/compact",
        opts?.withPhoneAssignments
          ? { params: { with_phone_assignments: true } }
          : undefined
      )
    ).data;
  }
};

export default api;
